import React from 'react';
import { contentV1PropTypes } from './ContentV1PropTypes';
import Picture from '@Theme/natucare/components/Picture/Picture';
import * as styles from './ContentV1.module.scss';
const ContentV1 = ({
  picture,
  description,
  buttons,
  buttonHeading
}) => {
  if (!picture && !description) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootBody
  }, picture.src && picture.alt && /*#__PURE__*/React.createElement("a", {
    href: buttons[0].href,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Picture, {
    xs: {
      src: picture.src
    },
    alt: picture.alt,
    pictureClassname: styles.rootPicture,
    imgClassname: styles.rootImage
  })), description && /*#__PURE__*/React.createElement("div", {
    className: styles.rootDescription,
    dangerouslySetInnerHTML: {
      __html: description
    }
  })), buttons && /*#__PURE__*/React.createElement("div", {
    className: styles.rootButtons
  }, buttons.map(({
    label,
    href
  }, index) => {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, label && href && /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noopener noreferrer",
      href: href,
      className: styles.rootButton
    }, label));
  })));
};
export default ContentV1;